import React from "react";

import { Spinner } from "@components/General/Spinner/spinner.component";

export const SearchResultsSkeleton = () => {
    return (
        <div id="search__loading" className="search__loading">
            <div className="search__loading__overlay">
                <Spinner />
            </div>
        </div>
    );
};
